export default __webpack_public_path__ + "static/media/login_illustration.c54928b2.svg";